export default "__VITE_ASSET__BHGdZJ07__"